/* eslint-disable no-console */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';

import { IHttpErrorHandler, IAPIErrorHandlingOptions } from '@sondermind/utilities/models-http';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorService implements IHttpErrorHandler {
  handleHttpError<T>(err: HttpErrorResponse, options: IAPIErrorHandlingOptions): Observable<T | null> {
    if (err.status === 401 || err.status === 403) {
      if (options.null401) {
        return of(null);
      }
    }

    if (options.null404 && (err.status === 404)) {
      return of(null);
    }

    return this.parseAndThrowError(err);
  }

  /**
   * Performs the same logic as handleHttpError except it will never return an Observable<null>
   */
  handleHttpErrorStrict<T>(err: HttpErrorResponse): Observable<T> {
    return this.parseAndThrowError(err);
  }

  private parseAndThrowError(err: HttpErrorResponse): Observable<never> {
    // when the server couldn't respond at all - network errors, bug in httpclient, etc.
    if (err.error instanceof ErrorEvent) {
      console.error(err);
      return throwError(() => ({ base: [err.message] }));
    }

    // the server responded, but it maybe coming from proxies, etc, so might not be in the right format
    if (typeof err.error === 'string') {
      console.error(err);
      return throwError(() => ({ base: [err.message] }));
    }

    // the server responded, and it looks nominally like it's in our format
    if (typeof err.error === 'object' && err.error.errors) {
      console.error(err);
      return throwError(() => err.error.errors);
    }

    // no idea at this point, generic error message, but in the right format
    console.error(err);
    return throwError(() => ({ base: ['Something bad happened, sorry!'] }));
  }
}
